import styled from "styled-components";
export const themed = (component) => styled(component) `
  & {
    position: relative;
    width: 100%;
    height: 0;

    /* aspect ratio needs to be inverted for horizontal viewing */
    padding-bottom: ${({ ratio: aspectRatio }) => (1 / aspectRatio) * 100}%;

    .innerWrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  /* the 1.77 isn't that important, just neeeded a value to check if aspect ratio is supported */
  @supports (aspect-ratio: 1.77) {
    & {
      aspect-ratio: ${({ ratio: aspectRatio }) => aspectRatio};
      padding-bottom: 0;
      height: auto;
    }
  }
`;
//# sourceMappingURL=styles.js.map